import Client from '@/repositories/Clients/AxiosClient'
import Config from '@/repositories/Clients/AxiosDefaultConfig'

const resource = `${Config.basePath}/anyibao/enterprises`

export default {
  options(payload) {
    return Client.get(`${resource}/option`, {
      params: payload,
    })
  },
  productList(params) {
    return Client.get(`${Config.basePath}/service-system/product`, {
      params,
    })
  },
}
